import BigNumber from 'bignumber.js';

export default function getDecimalsCount(value: BigNumber | string): number {
  const stringValue = typeof value === 'string' ? value : value.toFixed();
  const hasDecimals = stringValue.includes('.');

  return hasDecimals ? stringValue.split('.')[1].length : 0;
}
